import { z } from 'zod';
export const instrumentSchema = z.object({
    id: z.number().int().positive(),
    symbol: z.string().min(1).max(32),
    description: z.string(),
    digits: z.number().int().min(0).max(10),
    point: z.number().positive(),
    tickSize: z.number().positive(),
    contractSize: z.number().positive(),
    profitCurrency: z.string(),
    storedGmtOffsetSec: z.number().int(),
    enabled: z.boolean(),
});
/**
 * Price movement of one "pip", for display and risk sizing.
 *
 * This is a desk convention, not a broker field. For 2-digit gold the usual
 * convention is 1 pip = 0.10, so a $1 move is 10 pips. Derived from `digits`
 * rather than stored, so it stays correct if the broker quotes 3 digits.
 */
export function pipSize(instrument) {
    return instrument.digits >= 1 ? 10 ** -(instrument.digits - 1) : 1;
}
export function toPips(instrument, distance) {
    return distance / pipSize(instrument);
}
export function fromPips(instrument, pips) {
    return pips * pipSize(instrument);
}
export function roundPrice(instrument, price) {
    const f = 10 ** instrument.digits;
    return Math.round(price * f) / f;
}
//# sourceMappingURL=instrument.js.map